import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { ConnectedProps, connect, useDispatch } from 'react-redux';
import { Skeleton } from 'antd';
import { MinhaContaActions } from 'Store/MinhaConta/MinhaConta.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { AuthActions } from 'Store/Auth/Auth.actions';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import BreadCrumb from 'Components/UI/BreadCrumb';
import { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import DetalhesConta from './DetalhesConta/DetalhesConta';
import DadosEmpresa from './DadosEmpresa/DadosEmpresa';
import UpdateConta from './Modals/UpdateConta';
import UpdateEmpresa from './Modals/UpdateEmpresa';
import UpdatePassword from './Modals/UpdatePassword';
import styles from './MinhaConta.module.scss';

const MinhaConta: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(MinhaContaActions.getUserInfo());
    dispatch(AuthActions.listCompanyPosition());

    const QS: string[] = (location?.search || '').replace('?', '').split('&');
    QS.forEach((queryParam) => {
      if (queryParam === 'show=0' && !props.isLoading) {
        dispatch(MinhaContaActions.setShowModalUpdateConta(true));
      } else if (queryParam === 'show=1' && !props.isLoading) {
        dispatch(MinhaContaActions.setShowModalUpdateEmpresa(true));
      }
    });
  }, []);

  const companyPositions = props.lisCompanyPosition?.map((role) => ({
    value: role.CompanyPositionId,
    description: role.Name,
    label: role.Name
  }));

  const breadCrumbs: IBreadcrumbItem[] = [
    {
      description: 'Minha Conta',
      href: '/conta',
    },
  ];

  return (
    <PageHeader name='Minha conta'>
      <BreadCrumb breadcrumbs={breadCrumbs} />

      {
        props.isLoading
          ? <Skeleton active className={styles['MinhaContaSkeleton']} />
          : (<>
            <div className={styles['MinhaContaWrapper']}>
              <DetalhesConta />
            </div>
            {
              props.userInfo?.CompanyPosition?.Type === 1 && props.userInfo?.CurrentRoleFk === 1
                ? (
                  <div className={styles['MinhaContaWrapper']}>
                    <DadosEmpresa />
                  </div>
                )
                : <></>
            }
          </>)
      }

      {props.showModalUpdateConta && (
        <UpdateConta
          visible={props.showModalUpdateConta}
          userInfos={props.userInfo}
          isLoading={props.generalLoading}
          companyPositions={companyPositions}
          onCancel={() => dispatch(MinhaContaActions.setShowModalUpdateConta(false))}
        />
      )}
      <UpdatePassword
        visible={props.showModalUpdatePassword}
        userInfoId={props.userInfo?.Id || ''}
        onCancel={() => dispatch(MinhaContaActions.setShowModalUpdatePassword(false))}
      />
      <UpdateEmpresa
        visible={props.showModalUpdateEmpresa}
        userInfos={props.userInfoGet || undefined}
        onCancel={() => dispatch(MinhaContaActions.setShowModalUpdateEmpresa(false))}
      />
    </PageHeader>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.minhaConta,
  lisCompanyPosition: state.auth.listCompanyPosition,
  userInfoGet: state.auth.userInfo,
});

const connector = connect(
  mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;


export default connector(MinhaConta);
